// The board under "Ready to deploy" (Poulpe-556), in Ready to merge's look
// (ReadyColumns.tsx): a column that holds issues awaiting a release widens,
// the others fold to narrow rails. In a wide column its issues stand under
// each channel of the project's release map that would ship them, by the
// channel's name and in the map's order; an issue that awaits two channels
// stands under both. Nothing here drags, picks or deploys.
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { StateIcon } from '../components/Icons'
import { surfaceNamesOf } from '../lib/releases'
import { useBoardState } from '../store/context'
import { stateName } from '../vocab'
import { CardBody } from './Card'
import { shipments } from './deploy'
import type { ColumnData } from './filters'
import './ready.css'

export function DeployColumns({ columns }: { columns: ColumnData[] }) {
  const { labels, me, projects, selectedProjectId } = useBoardState()
  const project = projects.get(selectedProjectId ?? '')
  const surfaceNames = surfaceNamesOf(project)
  const map = project?.release_map
  const byColumn = useMemo(() => new Map(columns.map((column) =>
    [column.key, shipments(selectedProjectId, column.items, map).filter((s) => s.issues.length > 0)])), [columns, selectedProjectId, map])
  return <div className="ready-board" tabIndex={-1} role="region" aria-label="Ready to deploy">
    <div className="columns ready-columns">{columns.map((column) => {
      const { key, state } = column
      const name = column.column?.name ?? stateName(state)
      const groups = byColumn.get(key) ?? []
      if (column.items.length === 0) return <section key={key} className={`column column-${state} ready-rail`} aria-labelledby={`column-title-${key}`} title={`${name}: nothing ready to deploy`}>
        <header className="column-header"><StateIcon state={state} /><h2 id={`column-title-${key}`}>{name}</h2><span className="column-count" aria-label="0 issues shown">0</span></header>
      </section>
      return <section key={key} className={`column column-${state} ready-wide`} aria-labelledby={`column-title-${key}`}>
        <header className="column-header">
          <StateIcon state={state} /><h2 id={`column-title-${key}`}>{name}</h2>
          <span className="column-count" aria-label={`${column.items.length} issues shown`}>{column.items.length}</span>
          <span className="ready-column-note">Awaiting a release</span>
        </header>
        <div className="column-body">{groups.map(({ channel, issues }) => <section key={channel} className="deploy-channel" aria-label={`${channel} would ship`}>
          <h3 className="deploy-channel-title">{channel} <span className="muted">· {issues.length} to ship</span></h3>
          {issues.map((issue) => <article key={issue.id} className="card ready-card" data-board-card={issue.id} aria-label={`${issue.key} ${issue.title}`}>
            <Link className="card-link" to={`/${encodeURIComponent(issue.key)}`}><CardBody issue={issue} labels={labels} me={me} surfaceNames={surfaceNames} /></Link>
          </article>)}
        </section>)}</div>
      </section>
    })}</div>
  </div>
}
